import React from 'react'
import './winner-header.scss'

const WinnerHeader = props => {
    return (
        <>
            <div className="f-header-winner">
                <div className="f-header-site-container">
                    <div className="f-header-site-container-title">
                        <span>GANADORAS</span>
                        <h1>{props.params.titulo}</h1>
                    </div>
                    <div className="f-header-site-container-text" >
                        <p>{props.params.descripcionConcurso.descripcionConcurso}</p>
                    </div>
                 
                </div>
            </div>
        </>
    )
}

export default WinnerHeader
